
document.addEventListener('DOMContentLoaded', function() {
  
  const bottomColumns = document.querySelectorAll('.ecom-qxqg1td37gb>.core__row--columns>.ecom-column');

  if( bottomColumns.length ) {
    bottomColumns.forEach(column => {

      column.addEventListener('click', function(e) {

        e.preventDefault();
        e.stopPropagation();
        
        let item = e.target;
        
        const parentElement = item.closest(".booking-link");
        if( parentElement ) {
          const link = parentElement.querySelector('a');
          if( link ) {
           window.open(link.href, '_blank');
          }
        }
      });

      column.addEventListener('mouseenter', function(e) {

        let item = e.target;
        const a = item.querySelector('a');
        if( a ) {
          a.classList.add('active');
        }
      });

      column.addEventListener('mouseleave', function(e) {

        let item = e.target;
        const a = item.querySelector('a');
        if( a ) {
          a.classList.remove('active');
        }
      });
      
    });
  }
});